<div class="panel panel-cell panel-thead">
	<div class="row no-gutters">

		@if (hasPlanDetails()) {
		<div class="col short-col"></div>
		}
		@if (hasPlanDetails()) {
		<div data-testid="SUBSYS5_PATLIST_HEADER_PATID" class="col" [class.active]="activeColumn() === fields.patientId">
			<tsp-sortable-header [name]="fields.patientId" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_ID }}
			</tsp-sortable-header>
		</div>
		} @else {
		<div data-testid="SUBSYS5_PATLIST_HEADER_PATID" class="col no-link">
			{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_ID }}
		</div>
		}
		@if (hasPlanDetails()) {
		<div data-testid="SUBSYS5_PATLIST_HEADER_INITIALS" class="col"
			[class.active]="activeColumn() === fields.patInitials">
			<tsp-sortable-header [name]="fields.patInitials" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_INITIALS }}
			</tsp-sortable-header>
		</div>
		} @else {
		<div data-testid="SUBSYS5_PATLIST_HEADER_INITIALS" class="col no-link">
			{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_INITIALS }}
		</div>
		}
		@if (hasPlanDetails()) {
		<div data-testid="SUBSYS5_PATLIST_HEADER_GENDER" class="col" [class.active]="activeColumn() === fields.patGender">
			<tsp-sortable-header [name]="fields.patGender" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_GENDER }}
			</tsp-sortable-header>
		</div>
		} @else {
		<div data-testid="SUBSYS5_PATLIST_HEADER_GENDER" class="col no-link">
			{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_GENDER }}
		</div>
		}
		@if (hasPlanDetails()) {
		<div data-testid="SUBSYS5_PATLIST_HEADER_LASTPUBLISHDATE" class="col"
			[class.active]="activeColumn() === fields.lastCasePublish">
			<tsp-sortable-header [name]="fields.lastCasePublish" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_PUBLISH_DATE }}
			</tsp-sortable-header>
		</div>
		} @else {
		<div data-testid="SUBSYS5_PATLIST_HEADER_LASTPUBLISHDATE" class="col no-link">
			{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_PUBLISH_DATE }}
		</div>
		}
		@if (hasPlanDetails()) {
		<div data-testid="SUBSYS5_PATLIST_HEADER_PUBLISHFRAMES" class="col"
			[class.active]="activeColumn() === fields.framePublishCount">
			<tsp-sortable-header [name]="fields.framePublishCount" (sort)="onSort($event)">
				{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_FRAMES }}
			</tsp-sortable-header>
		</div>
		} @else {
		<div data-testid="SUBSYS5_PATLIST_HEADER_PUBLISHFRAMES" class="col no-link">
			{{ labels().PATIENT_TABLE_COMPONENT_PATIENT_FRAMES }}
		</div>
		}
		<div data-testid="SUBSYS5_PATLIST_HEADER_ACTIONS" class="col no-link stretch-col"
			[class.shrinked]="!isFiltersCollapsed()">
			{{ labels().PATIENT_TABLE_COMPONENT_ACTIONS }}
		</div>

	</div>
</div>

@for (pat of patients(); track pat.id) {
<div class="panel panel-cell panel-tr" [class.panel-selectable]="hasPlanDetails()" (click)="pat.opened = !pat.opened"
	(keypress)="pat.opened = !pat.opened">
	<div class="row no-gutters">

		@if (hasPlanDetails()) {
		<div class="col short-col">
			<span data-testid="SUBSYS5_PATLIST_TOGGLE" class="material-icons panel-toggle">
				{{ pat.opened ? 'expand_less' : 'expand_more'}}
			</span>
		</div>
		}
		<div data-testid="SUBSYS5_PATLIST_CELL_PATID" class="col">
			@if (hasPlanDetails()) {
			{{ pat.number }}
			} @else {
			<a href="" onclick="return false;" (click)="patientSettings(pat.id)">
				{{ pat.number }}
			</a>
			}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_INITIALS" class="col">
			{{ pat.initials }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_GENDER" class="col">
			<div class="user-holder" [class]="genderClass(pat.gender)">
				<span>{{ pat.gender }}</span>
			</div>
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_LASTPUBLISHDATE" class="col">
			{{ (pat.lastCasePublish | convertDate:false) ?? '--' }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_PUBLISHFRAMES" class="col">
			{{ !!pat.framePublishCount ? pat.framePublishCount : '--' }}
		</div>
		<div data-testid="SUBSYS5_PATLIST_CELL_ACTIONS" class="col no-link stretch-col"
			[class.shrinked]="!isFiltersCollapsed()">
			<div ngbDropdown container="body">
				<i data-testid="SUBSYS5_PATLIST_ACTION_PATSETTINGS" class="material-icons action"
					[title]="labels().PATIENT_TABLE_COMPONENT_PATSETTINGS_BTN" (click)="patientSettings(pat.id)"
					(keypress)="patientSettings(pat.id)">
					manage_accounts
				</i>
				<i data-testid="SUBSYS5_PATLIST_ACTION_PATHISTORY" class="material-icons action"
					[title]="labels().PATIENT_TABLE_COMPONENT_PATHISTORY_BTN" (click)="patientHistory(pat.id)"
					(keypress)="patientHistory(pat.id)">
					history
				</i>
			</div>
		</div>

	</div>
</div>

@if (hasPlanDetails()) {
<div [ngbCollapse]="!pat.opened">
	<div class="panel-content">
		<div class="panel panel-tr-content">
			<div class="row no-gutters">
				<div class="col">

					<tsp-plan-table [plans]="pat.treatments" [isFiltersCollapsed]="isFiltersCollapsed()" />

				</div>
			</div>
		</div>
	</div>
</div>
}
}